/**
 * src/lib/debug/debugGate.js — Phase Z mount gate.
 * Isolated so AppShell.jsx and DebugPanel share one source of truth.
 */
export function shouldMountDebugPanel(effectiveRole, flagEnabled) {
  return effectiveRole === 'ceo' && flagEnabled === true;
}
